import { useState } from 'react';
import styled from 'styled-components';

import { InputText } from 'ui/inputs';
import { Search16 } from 'ui/icons';
import { x16 } from 'ui/theme/spacing';
import { useDebouncedEffect } from 'utils/hooks/useDebouncedEffect';
import { DEFAULT_DEBOUNCE_TIME } from 'utils/helpers';
import { useTranslation } from 'modules/domains/list';

import { useFiltersContext } from '../../contexts';

const Input = styled(InputText)`
  width: ${x16};
`;

export const Search = () => {
  const { t } = useTranslation();
  const placeholder = t('indexPage.filters.search.placeholder');
  const { search, setSearch } = useFiltersContext();
  const [immediateValue, setImmediateValue] = useState(search);

  useDebouncedEffect(
    () => {
      setSearch(immediateValue);
    },
    [immediateValue],
    { debounceTimeout: DEFAULT_DEBOUNCE_TIME, skipEffectOnMount: true },
  );

  return (
    <Input
      data-test="search-input"
      value={immediateValue}
      onChange={setImmediateValue}
      Prefix={<Search16 isColorInherited />}
      placeholder={placeholder}
    />
  );
};
